const allSelectors = [];

export default function( selector ) {
	allSelectors.push( selector );
	let selectors = allSelectors.join(',');

	if ( allSelectors.length > 1 ) {
		return;
	}

	const ontouchstart = (e) => {
		let node = e.target;

		while ( node && node.parentNode ) {
			if ( node.matches( selectors ) ) {
				if ( node.dataset.focused ) {
					return;
				}

				node.addEventListener( 'click', onclick );
			}

			node = node.parentNode;
		}
	}

	const onclick = ( e ) => {
		let node = e.target;

		while ( node && node.parentNode ) {
			if ( node.matches( selectors ) ) {
				node.removeEventListener( 'click', onclick );

				if ( node.dataset.focused ) {
					return;
				}

				if ( e.preventDefault ) {
					e.preventDefault();
				}

				node.dataset.focused = '1';
				return node.focus();
			}

			node = node.parentNode;
		}
	}

	const onblur = ( e ) => {
		let node = e.target;

		while ( node && node.parentNode ) {
			if ( node.dataset.focused ) {
				delete node.dataset.focused;
			}

			node = node.parentNode;
		}
	}

	document.addEventListener( 'blur', onblur, true );
	document.addEventListener( 'touchstart', ontouchstart );
}
